<template>
    <app-layout title="Facturatieklanten">
        <template #header>
            <page-title title="Facturatieklanten" />
        </template>

        <template #pageContent>
            <p>
                Geef hier het startnr. in, vanaf waar de klantennrs. moeten starten.<br>
                Als er geen startnr. is ingevuld, zullen er geen automatische klantennrs. worden aangemaakt.
            </p>
            <Form @submitted="postForm" layout="horizontal" class="w-1/3">
                <Input
                    type="number"
                    label="Startnummer"
                    name="start_number"
                    v-model="form.start_number"
                    :error="form.errors.start_number"
                    layout="vertical"
                />
                <Button
                    buttonClass="download"
                    text="Exporteer klanten"
                    type="submit"
                    :loading="form.processing"
                />
            </Form>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import TableSearch from '@/Components/TableSearch.vue'
import Form from '@/Components/Form.vue'
import Input from '@/Components/Input.vue'

import store from '@/store'
import {useForm} from "@inertiajs/inertia-vue3"

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        TableSearch,
        Form,
        Input,
    },
    props: [

    ],
    setup (props){

        const form = useForm({
            start_number: null,
        })

        function postForm()
        {
            // form.post(route('accountancy.invoice-customers.export'))

            axios.post(route('accountancy.invoice-customers.export'),
                { start_number: form.start_number },
                { responseType: 'blob' }
            )
                .then((response) => {

                    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    let fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'Facturatieklanten.xlsx');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                })
                .catch(function (error) {
                    console.log(error)
            });
        }

        return {
            state: store.state,
            ...store,
            form,
            postForm,
        }
    },
}

</script>
